/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Prep_IntakeInputs */



/**
* | output |
* | --- |
* | "Build my preparation" |
*
* @param {Chat_Quick_Prep_IntakeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_prep_intake = /** @type {((inputs?: Chat_Quick_Prep_IntakeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Prep_IntakeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding opstellen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer la préparation")
	return /** @type {LocalizedString} */ ("Build my preparation")
});